import { AiseaApiFactory } from "../../../api/aisea/apiFactory";

const enterpriseManningVesselsApi = AiseaApiFactory.get(
  "enterpriseManningVessels"
);
const enterpriseOnboardingCrewsApi = AiseaApiFactory.get(
  "enterpriseOnboardingCrews"
);
const enterpriseAshoreCrewsApi = AiseaApiFactory.get("enterpriseAshoreCrews");
const enterpriseManningVesselsAlertsApi = AiseaApiFactory.get(
  "enterpriseManningVesselAlerts"
);
const enterpriseCrewsAlertsApi = AiseaApiFactory.get("enterpriseCrewsAlerts");

const enterpriseCrewsRolesApi = AiseaApiFactory.get("enterpriseCrewsRoles");

const enterpriseCrewAlertSettingsApi = AiseaApiFactory.get(
  "enterpriseCrewAlertSettings"
);

export default {
  async fetchEnterpriseManningVessels({ commit }, params) {
    const response = await enterpriseManningVesselsApi.fetch(params);
    if (!response || !response.status) {
      throw response;
    } else {
      commit("SET_ENTERPRISE_MANNING_VESSELS", response.data.manning_vessels);
    }
  },

  async fetchEnterpriseOnboardingCrews({ commit }, params) {
    const response = await enterpriseOnboardingCrewsApi.fetch(params);
    if (!response || !response.status) {
      throw response;
    } else {
      commit("SET_ENTERPRISE_ONBOARDING_CREWS", response.data.on_boarding_crews);
    }
  },

  async fetchEnterpriseAshoreCrews({ commit }, params) {
    const response = await enterpriseAshoreCrewsApi.fetch(params);
    if (!response || !response.status) {
      throw response;
    } else {
      commit("SET_ENTERPRISE_ASHORE_CREWS", response.data.ashore_crews);
    }
  },

  async fetchEnterpriseManningVesselAlerts({ commit }, params) {
    const response = await enterpriseManningVesselsAlertsApi.fetch(params);
    if (!response || !response.status) {
      throw response;
    } else {
      commit("SET_ENTERPRISE_MANNING_VESSEL_ALERTS", response.data.alerts);
    }
  },

  async fetchEnterpriseCrewsAlerts({ commit }, params) {
    const response = await enterpriseCrewsAlertsApi.fetch(params);
    if (!response || !response.status) {
      throw response;
    } else {
      commit("SET_ENTERPRISE_CREWS_ALERTS", response.data.alerts);
    }
  },

  async fetchEnterpriseCrewsRoles({ commit }) {
    const response = await enterpriseCrewsRolesApi.fetch();
    if (!response || !response.status) {
      throw response;
    } else {
      commit("SET_ENTERPRISE_CREWS_ROLES", response.data.roles);
    }
  },

  async fetchEnterpriseCrewAlertSettings({ commit }, params) {
    const response = await enterpriseCrewAlertSettingsApi.fetch(params);
    if (!response || !response.status) {
      throw response;
    } else {
      commit("SET_ENTERPRISE_CREW_ALERT_SETTINGS", response.data.alert_settings);
    }
  }
};
